<div class="card" style="border-radius: 10px">
  <div class="card-body">
    <div class="row text-left">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between mb-0">
          <h1 class="text-bold-400" style="color: #4e7977">
            Usuários Conferidores
          </h1>
        </div>
      </div>
      <div class="col-sm-12">
        <p class="mb-2 mt-2" style="font-size: 20px">
          Visualize e gerencie todos os conferidores do sistema.
          Utilize a busca e os filtros para encontrar e atualizar informações de
          forma eficiente.
        </p>
      </div>
    </div>

    <form #conferidorForm="ngForm" novalidate>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="municipio">Cliente</label>
              <ng-select
                [items]="municipios"
                bindLabel="nome"
                bindValue="id"
                [(ngModel)]="filters.municipio"
                name="municipio"
                placeholder="Selecione um Município"
                [clearable]="true"
                [searchable]="true"
                [loading]="municipiosLoading"
                (search)="onMunicipioSearch($event)"
                (scrollToEnd)="onMunicipioScrollToEnd()"
                [virtualScroll]="true"
              >
                <ng-template ng-option-tmp let-item="item">
                  {{ item.nome }} <span *ngIf="item.uf" class="text-muted">- {{ item.uf }}</span>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="nome">Nome</label>
              <fieldset class="form-group position-relative has-icon-right">
                <input
                  type="text"
                  id="nome"
                  class="form-control"
                  [(ngModel)]="filters.nome"
                  name="nome"
                  placeholder="Digite o nome do conferidor"
                  aria-invalid="false"
                />
                <div class="form-control-position">
                  <i class="ft-search"></i>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="login">Usuário/Login</label>
              <fieldset class="form-group position-relative has-icon-right">
                <input
                  type="text"
                  id="login"
                  class="form-control"
                  [(ngModel)]="filters.login"
                  name="login"
                  placeholder="Digite o login do usuário"
                  aria-invalid="false"
                />
                <div class="form-control-position">
                  <i class="ft-search"></i>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <label for="data_cadastro">Período de Cadastro</label>
            <div class="d-flex">
              <div class="input-group">
                <input
                  type="text"
                  id="data_cadastro"
                  class="form-control"
                  mask="00/00/0000"
                  [(ngModel)]="filters.periodoCadastroInicio"
                  name="data_cadastro_inicio"
                  placeholder="dd-mm-yyyy"
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
              <span class="mx-2 d-flex align-items-center">até</span>
              <div class="input-group">
                <input
                  type="text"
                  id="data_cadastro_fim"
                  class="form-control"
                  mask="00/00/0000"
                  [(ngModel)]="filters.periodoCadastroFim"
                  name="data_cadastro_fim"
                  placeholder="dd-mm-yyyy"
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    
    <div class="form-row d-flex justify-content-end align-items-center">
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="clearFilters()"
        >
          Limpar filtros
        </button>
      </div>
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-primary mb-2 mb-md-0"
          (click)="applyFilters()"
        >
          Pesquisar <i class="fa fa-search mr-1"></i>
        </button>
      </div>
    </div>

    <hr>

    <div class="form-row d-flex justify-content-end">
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-primary"
          (click)="openCadastroModal(cadastroConferidor)"
        >
          <i class="fa fa-plus mr-2"></i>Adicionar Usuário
        </button>
      </div>
    </div>
  </div>
</div>

<div class="card" style="border-radius: 10px">
  <table class="table text-center table-striped" style="padding: 10px">
    <thead>
      <tr>
        <th (click)="sortTable('nome')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Nome
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('nome')"
                class="fa"
                [ngClass]="getSortIcon('nome')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('login')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Login
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('login')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('login')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('login')"
                class="fa"
                [ngClass]="getSortIcon('login')"
              ></i>
            </div>
          </div>
        </th>
        <th>Edição e exclusão de matrículas</th>
        <th>Edição completa pós-conferência</th>
        <th>
          <div class="d-flex align-items-center justify-content-center"></div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let conferidor of conferidores">
        <td class="pl-3 pr-3 align-middle">
          <div class="d-flex align-items-center justify-content-center texto-linha-tabela">
            {{ conferidor.nome }}
          </div>
        </td>
        <td class="text-center align-middle texto-linha-tabela">
          {{ conferidor.login }}
        </td>
        <td class="text-center align-middle">
          <span
            class="badge"
            [ngClass]="conferidor.pode_excluir_matricula == 1 ? 'badge-success' : 'badge-secondary'"
          >
            {{ conferidor.pode_excluir_matricula == 1 ? 'Liberadas' : 'Bloqueadas' }}
          </span>
        </td>
        <td class="text-center align-middle">
          <span
            class="badge"
            [ngClass]="conferidor.pode_editar_servidor_conferido == 1 ? 'badge-success' : 'badge-secondary'"
          >
            {{ conferidor.pode_editar_servidor_conferido == 1 ? 'Liberada' : 'Bloqueada' }}
          </span>
        </td>
        <td class="d-flex justify-content-end align-items-center">
          <button
            type="button"
            (click)="alternarPermissaoEdicaoServidor(conferidor)"
            class="btn action-btn mr-1 btn-square"
            [ngClass]="conferidor.pode_editar_servidor_conferido == 1 ? 'btn-outline-warning' : 'btn-outline-success'"
            [title]="conferidor.pode_editar_servidor_conferido == 1 ? 'Revogar edição completa pós-conferência' : 'Liberar edição completa pós-conferência'"
          >
            <i class="fa" [ngClass]="conferidor.pode_editar_servidor_conferido == 1 ? 'fa-lock' : 'fa-unlock'"></i>
          </button>
          <button
            type="button"
            (click)="alternarPermissaoExclusao(conferidor)"
            class="btn action-btn mr-1 btn-square"
            [ngClass]="conferidor.pode_excluir_matricula == 1 ? 'btn-outline-warning' : 'btn-outline-success'"
            [title]="conferidor.pode_excluir_matricula == 1 ? 'Revogar edição e exclusão de matrículas' : 'Liberar edição e exclusão de matrículas'"
          >
            <i class="fa" [ngClass]="conferidor.pode_excluir_matricula == 1 ? 'fa-lock' : 'fa-unlock'"></i>
          </button>
          <button 
            type="button" 
            (click)="deleteConferidor(conferidor)" 
            class="btn btn-outline-danger action-btn mr-1 btn-square"
            title="Inativar conferidor"
          >
            <i class="fa fa-user-times"></i>
          </button>
          <button 
            type="button" 
            (click)="openEditarMunicipiosModal(editarMunicipios, conferidor)" 
            class="btn btn-outline-info action-btn mr-1 btn-square"
            title="Editar municípios"
          >
            <i class="fa fa-map-marker"></i>
          </button>
          <button 
            type="button" 
            (click)="openModal(atualizarSenha, conferidor)" 
            class="btn btn-outline-primary action-btn btn-retangle"
          >
            Alterar Senha
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  
  <div class="form-row" *ngIf="total > 0" style="padding: 0px 20px">
    <div class="d-flex justify-content-between align-items-center w-100">
      <div>
         Exibindo {{(page-1) * pageSize + 1}} a {{Math.min(page * pageSize, total)}} de {{total}} itens
      </div>
      <div class="d-flex justify-content-center">
        <ngb-pagination
          class="ml-auto pagination-square"
          style="margin-top: 10px; margin-right: 10px"
          *ngIf="total > 0"
          [(page)]="page"
          [pageSize]="pageSize"
          [maxSize]="3"
          [rotate]="true"
          [boundaryLinks]="true"
          size="sm"
          [collectionSize]="total"
          (pageChange)="onPageChange($event)"
        ></ngb-pagination>
      </div>
    </div>
  </div>
</div>

<div class="card" style="border-radius: 10px" *ngIf="conferidores.length == 0">
  <div class="card-body">
    <div class="text-center">
      <h5 class="mt-0">Nenhum conferidor encontrado.</h5>
      <p class="text-muted">Ajuste os filtros ou cadastre um novo conferidor.</p>
    </div>
  </div>
</div>

<!-- Modal Cadastro Conferidor -->
<ng-template #cadastroConferidor let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Novo Usuário</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #cadForm="ngForm" novalidate>
      <div class="row">
        <div class="col-12">
          <h5 class="mb-3">Informações Básicas</h5>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12">
          <div class="form-group">
            <div class="controls">
              <label for="cadastro_municipio">Municípios</label>
              <ng-select
                [items]="municipios"
                bindLabel="nome"
                bindValue="id"
                [(ngModel)]="municipiosSelecionados"
                name="cadastro_municipio"
                placeholder="Selecione os Municípios"
                [clearable]="true"
                [searchable]="true"
                [multiple]="true"
                [loading]="municipiosLoading"
                (search)="onMunicipioSearch($event)"
                (scrollToEnd)="onMunicipioScrollToEnd()"
                [closeOnSelect]="false"
                [virtualScroll]="true"
                appendTo="body"
              >
                <ng-template ng-option-tmp let-item="item">
                  {{ item.nome }} <span *ngIf="item.uf" class="text-muted">- {{ item.uf }}</span>
                </ng-template>
              </ng-select>
              <small class="text-muted">Selecione um ou mais municípios que o conferidor terá acesso</small>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <div class="controls">
              <label for="cadastro_nome">Nome <b style="color: red">*</b></label>
              <input 
                type="text" 
                id="cadastro_nome" 
                class="form-control" 
                name="cadastro_nome" 
                [(ngModel)]="novoConferidor.nome" 
                placeholder="Nome completo"
                required
              >
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <div class="controls">
              <label for="cadastro_login">Usuário/Login <b style="color: red">*</b></label>
              <input 
                type="text" 
                id="cadastro_login" 
                class="form-control" 
                name="cadastro_login" 
                [(ngModel)]="novoConferidor.login" 
                placeholder="Nome de usuário"
                required
              >
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12 col-md-6">
          <div class="form-group">
            <div class="controls">
              <label for="cadastro_senha">Senha <b style="color: red">*</b></label>
              <input 
                type="password" 
                id="cadastro_senha" 
                class="form-control" 
                name="cadastro_senha" 
                [(ngModel)]="novoConferidor.senha" 
                placeholder="Senha"
                required
              >
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <div class="controls">
              <label for="cadastro_confirmaSenha">Confirmar Senha <b style="color: red">*</b></label>
              <input 
                type="password" 
                id="cadastro_confirmaSenha" 
                class="form-control" 
                name="cadastro_confirmaSenha" 
                [(ngModel)]="novoConferidor.confirmaSenha" 
                placeholder="Confirmar senha"
                required
              >
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12">
          <div class="form-group form-check">
            <input
              type="checkbox"
              id="cadastro_pode_excluir_matricula"
              class="form-check-input"
              name="cadastro_pode_excluir_matricula"
              [(ngModel)]="novoConferidor.pode_excluir_matricula"
            >
            <label class="form-check-label" for="cadastro_pode_excluir_matricula">
              Permitir edição e exclusão de matrículas durante a conferência
            </label>
            <small class="form-text text-muted">
              A edição ficará disponível na tela interna. A exclusão será lógica, exigirá motivo e poderá ser restaurada pelo administrador.
            </small>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12">
          <div class="form-group form-check">
            <input
              type="checkbox"
              id="cadastro_pode_editar_servidor_conferido"
              class="form-check-input"
              name="cadastro_pode_editar_servidor_conferido"
              [(ngModel)]="novoConferidor.pode_editar_servidor_conferido"
            >
            <label class="form-check-label" for="cadastro_pode_editar_servidor_conferido">
              Permitir edição completa após a conferência
            </label>
            <small class="form-text text-muted">
              Libera o mesmo acesso do fluxo de conferência, incluindo dados cadastrais, matrículas, movimentos e TSPs.
            </small>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer justify-content-between">
    <button 
      type="button" 
      class="btn btn-outline-primary" 
      (click)="modal.dismiss('Cancel')"
    >
      Voltar
    </button>
    <button 
      type="button" 
      class="btn btn-primary" 
      (click)="insertConferidor(modal)" 
      [disabled]="!novoConferidor || !novoConferidor.nome || !novoConferidor.login || !novoConferidor.senha || !novoConferidor.confirmaSenha || (novoConferidor.senha != novoConferidor.confirmaSenha)"
    >
      Cadastrar
    </button>
  </div>
  <ngx-spinner></ngx-spinner>
</ng-template>

<!-- Modal Editar Municípios -->
<ng-template #editarMunicipios let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Editar Municípios</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <p class="text-muted mb-1">Conferidor:</p>
      <h5>{{ conferidorEditando?.nome }}</h5>
    </div>
    <form #editMunForm="ngForm" novalidate>
      <div class="form-row">
        <div class="col-12">
          <div class="form-group">
            <div class="controls">
              <label for="editar_municipios">Municípios com Acesso</label>
              <ng-select
                [items]="municipiosEdicaoLista"
                bindLabel="nome"
                bindValue="id"
                [(ngModel)]="municipiosSelecionadosEdicao"
                name="editar_municipios"
                placeholder="Selecione os Municípios"
                [clearable]="true"
                [searchable]="true"
                [multiple]="true"
                [loading]="municipiosLoading"
                (search)="onMunicipioSearchEdicao($event)"
                (scrollToEnd)="onMunicipioScrollToEndEdicao()"
                [closeOnSelect]="false"
                [virtualScroll]="true"
                appendTo="body"
              >
                <ng-template ng-option-tmp let-item="item">
                  {{ item.nome }} <span *ngIf="item.uf" class="text-muted">- {{ item.uf }}</span>
                </ng-template>
              </ng-select>
              <small class="text-muted">Selecione os municípios que este conferidor terá acesso</small>
            </div>
          </div>
        </div>
      </div>
      
      <div *ngIf="municipiosSelecionadosEdicao.length > 0" class="mb-3">
        <small class="text-muted">Municípios selecionados: <strong>{{ municipiosSelecionadosEdicao.length }}</strong></small>
      </div>
    </form>
  </div>
  <div class="modal-footer justify-content-between">
    <button 
      type="button" 
      class="btn btn-outline-primary" 
      (click)="modal.dismiss('Cancel')"
    >
      Cancelar
    </button>
    <button 
      type="button" 
      class="btn btn-primary" 
      (click)="updateMunicipios(modal)"
    >
      <i class="fa fa-save mr-1"></i> Salvar Alterações
    </button>
  </div>
  <ngx-spinner></ngx-spinner>
</ng-template>

<!-- Modal Atualizar Senha -->
<ng-template #atualizarSenha let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Nova Senha</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #exForm="ngForm" novalidate>
      <div class="form-row">
        <div class="col-12">
          <div class="form-group">
            <div class="controls">
              <label for="novaSenha">Nova Senha <b style="color: red">*</b></label>
              <input 
                type="password" 
                id="novaSenha" 
                class="form-control" 
                name="novaSenha" 
                [(ngModel)]="atualizacaoSenha.novaSenha" 
                placeholder="Digite a nova senha"
                required
              >
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-12">
          <div class="form-group">
            <div class="controls">
              <label for="confirmaNovaSenha">Confirmar Nova Senha <b style="color: red">*</b></label>
              <input 
                type="password" 
                id="confirmaNovaSenha" 
                class="form-control" 
                name="confirmaNovaSenha" 
                [(ngModel)]="atualizacaoSenha.confirmaNovaSenha" 
                placeholder="Confirme a nova senha"
                required
              >
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer justify-content-between">
    <button 
      type="button" 
      class="btn btn-outline-primary" 
      (click)="modal.dismiss('Cancel')"
    >
      Cancelar
    </button>
    <button 
      type="button" 
      class="btn btn-primary" 
      (click)="updateSenha(modal)" 
      [disabled]="!atualizacaoSenha || !atualizacaoSenha.novaSenha || !atualizacaoSenha.confirmaNovaSenha || (atualizacaoSenha.novaSenha != atualizacaoSenha.confirmaNovaSenha)"
    >
      Atualizar
    </button>
  </div>
  <ngx-spinner></ngx-spinner>
</ng-template>

<ngx-spinner></ngx-spinner>
